/* =========================================================================
   WWC CRO-concept - kleine UX-ingrepen op de productpagina

   Drie losse dingen die te klein zijn voor een eigen bestand:
     1. kruimelpad: huisicoon + pad naar het eind scrollen
     2. materiaalkiezer: de lange helptekst inkorten op mobiel
     3. lightbox: schermvullend beeld met knijpen en vegen

   Uitschakelen: cro_ux op false in snippets/wwc-cro-fold.liquid
   ========================================================================= */

(function () {
  'use strict';

  var MOBILE = '(max-width: 899px)';

  /* =======================================================================
     1. KRUIMELPAD

     Na het weglaten van de productnaam eindigt het pad op de stad, en juist
     die laatste stap is de nuttigste voor de bezoeker. Bij een pad dat breder
     is dan het scherm zie je standaard het BEGIN (Home / Steden / Nederland),
     dus precies het minst nuttige deel. Daarom scrollen we naar het eind.
     ======================================================================= */
  function breadcrumb() {
    var list = document.querySelector('.breadcrumb--enhanced .breadcrumb__list');
    if (!list) return;

    var first = list.querySelector('a');
    if (first && /^\s*home\s*$/i.test(first.textContent || '')) {
      first.classList.add('cro-crumb-home');
      // Het icoon vervangt de tekst visueel; de naam blijft voor schermlezers.
      first.setAttribute('aria-label', first.textContent.trim() || 'Home');
      first.setAttribute('title', first.textContent.trim() || 'Home');
    }

    if (!window.matchMedia(MOBILE).matches) return;

    // Naar het eind, zodat de dichtstbijzijnde categorie in beeld staat.
    window.requestAnimationFrame(function () {
      if (list.scrollWidth > list.clientWidth) {
        list.scrollLeft = list.scrollWidth;
      }
    });
  }

  /* =======================================================================
     2. MATERIAALKIEZER - helptekst inkorten

     De intro luidt: "Kies alleen een andere look als die beter past bij jouw
     interieur of cadeau." Nuttig op desktop, maar op mobiel kost hij twee
     regels boven een lijst die toch al lang is. We zetten hem in een span die
     de CSS op mobiel verbergt; het aantal en de bandbreedte blijven staan,
     want dat is de helft die een keuze helpt maken.
     ======================================================================= */
  function materialIntro() {
    var intro = document.querySelector('.wwc-material-picker__intro');
    if (!intro || intro.querySelector('.wwc-cro-hidehelp')) return;

    Array.prototype.slice.call(intro.childNodes).forEach(function (node) {
      if (node.nodeType !== 3) return;               // alleen kale tekst
      if (!node.textContent.trim()) return;
      var span = document.createElement('span');
      span.className = 'wwc-cro-hidehelp';
      span.textContent = node.textContent;
      node.parentNode.replaceChild(span, node);
    });
  }

  /* =======================================================================
     3. LIGHTBOX

     Magic Zoom Plus opende het beeld schermvullend; de eigen galerij deed dat
     nog niet. Deze vervanger laat het zoomen aan de browser over: knijpen,
     dubbeltik en traagheid zijn daar beter geregeld dan in eigen code, en het
     scheelt een hoop JavaScript.
     ======================================================================= */
  function lightbox() {
    var gal = document.querySelector('wwc-product-gallery');
    if (!gal) return;

    /* Videoslides horen NIET in de lightbox: daar staat alleen de YouTube-
       poster, en die vergroten levert een dood beeld op met een play-knop die
       niets doet. De video speelt in de galerij zelf. Omdat de lightbox
       daardoor minder slides heeft dan de galerij, houden we per galerij-index
       bij op welke lightbox-index hij uitkomt. */
    var indexMap = {};
    var sources = Array.prototype.slice.call(gal.querySelectorAll('[data-gal-slide]'))
      .map(function (slide, galIndex) {
        if (slide.getAttribute('data-media-type') === 'video-embed') return null;
        var img = slide.querySelector('img');
        if (!img) return null;
        indexMap[galIndex] = -1;
        return {
          src: img.getAttribute('data-zoom-src') ||
               (slide.querySelector('[data-zoom-src]') || {}).dataset && slide.querySelector('[data-zoom-src]').dataset.zoomSrc ||
               img.currentSrc || img.src,
          alt: img.alt || ''
        };
      })
      .filter(Boolean);

    if (!sources.length) return;

    /* indexMap vullen: elke niet-video-slide krijgt zijn plek in de lightbox. */
    (function () {
      var n = 0;
      Array.prototype.forEach.call(gal.querySelectorAll('[data-gal-slide]'), function (slide, galIndex) {
        if (slide.getAttribute('data-media-type') === 'video-embed') return;
        if (!slide.querySelector('img')) return;
        indexMap[galIndex] = n++;
      });
    })();

    var box, track, count, thumbs;

    function build() {
      box = document.createElement('div');
      box.className = 'wwc-lb';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Afbeelding vergroot');

      track = document.createElement('div');
      track.className = 'wwc-lb__track';

      sources.forEach(function (s) {
        var slide = document.createElement('div');
        slide.className = 'wwc-lb__slide';
        var img = document.createElement('img');
        img.loading = 'lazy';
        img.decoding = 'async';
        img.src = s.src;
        img.alt = s.alt;
        slide.appendChild(img);
        track.appendChild(slide);
      });

      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'wwc-lb__close';
      close.setAttribute('aria-label', 'Sluiten');
      close.innerHTML = '&times;';
      close.addEventListener('click', hide);

      count = document.createElement('p');
      count.className = 'wwc-lb__count';

      /* Duimnagels onderin. Een teller ("3 / 11") zegt DAT er meer is, maar
         niet WAT. Met de strip zie je de andere beelden en spring je er direct
         heen - dat is waarom hij er eerder al zat. */
      if (sources.length > 1) {
        box.classList.add('wwc-lb--thumbs');
        thumbs = document.createElement('div');
        thumbs.className = 'wwc-lb__thumbs';
        sources.forEach(function (s, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'wwc-lb__thumb';
          b.setAttribute('aria-label', 'Afbeelding ' + (i + 1));
          var im = document.createElement('img');
          im.loading = 'lazy';
          im.decoding = 'async';
          im.src = s.src;
          im.alt = '';
          b.appendChild(im);
          b.addEventListener('click', function () {
            /* Direct toewijzen, geen smooth: de track is een scroll-snap-
               container en daar komt vloeiend programmatisch scrollen niet
               aan - de sprong wordt dan gewoon genegeerd. */
            track.scrollLeft = i * track.clientWidth;
            count.textContent = (i + 1) + ' / ' + sources.length;
            markThumb(i);
          });
          thumbs.appendChild(b);
        });
      }

      box.appendChild(track);
      box.appendChild(close);
      box.appendChild(count);
      if (thumbs) box.appendChild(thumbs);
      document.body.appendChild(box);

      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        count.textContent = (i + 1) + ' / ' + sources.length;
        markThumb(i);
      }, { passive: true });

      /* Toetsenbord op DOCUMENT, niet op de box: de focus kan na een klik op
         een duimnagel binnen de strip liggen, en dan bereikten pijltjes de
         box niet meer. Alleen actief zolang de lightbox open staat. */
      document.addEventListener('keydown', function (e) {
        if (!box || !box.classList.contains('is-open')) return;
        if (e.key === 'Escape') { hide(); return; }
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'Home' && e.key !== 'End') return;
        e.preventDefault();
        var huidig = Math.round(track.scrollLeft / track.clientWidth);
        var doel = huidig;
        if (e.key === 'ArrowLeft') doel = Math.max(0, huidig - 1);
        if (e.key === 'ArrowRight') doel = Math.min(sources.length - 1, huidig + 1);
        if (e.key === 'Home') doel = 0;
        if (e.key === 'End') doel = sources.length - 1;
        /* Direct toewijzen: scroll-snap negeert vloeiend programmatisch
           scrollen. */
        track.scrollLeft = doel * track.clientWidth;
        count.textContent = (doel + 1) + ' / ' + sources.length;
        markThumb(doel);
      });
    }

    /* Actieve duimnagel markeren en in beeld schuiven. Zonder dat laatste
       raak je hem kwijt zodra je voorbij de zichtbare strip veegt. */
    function markThumb(i) {
      if (!thumbs) return;
      var kids = thumbs.children;
      for (var k = 0; k < kids.length; k++) {
        var actief = k === i;
        kids[k].classList.toggle('is-current', actief);
        kids[k].setAttribute('aria-current', actief ? 'true' : 'false');
      }
      var cur = kids[i];
      if (cur) {
        var l = cur.offsetLeft - (thumbs.clientWidth / 2) + (cur.offsetWidth / 2);
        thumbs.scrollTo({ left: l, behavior: 'smooth' });
      }
    }

    var lastFocus = null;

    function show(index) {
      if (!box) build();
      lastFocus = document.activeElement;
      box.classList.add('is-open');
      document.body.classList.add('wwc-lb-open');
      /* Eén requestAnimationFrame is niet genoeg wanneer de lightbox in
         dezelfde tik wordt OPGEBOUWD: het element is dan nog niet opgemeten en
         clientWidth is 0, waardoor de sprong op de eerste slide landt en de
         teller leeg blijft. Daarom wachten tot er een breedte is, met een
         harde bovengrens zodat dit nooit blijft draaien. */
      var pogingen = 0;
      (function plaats() {
        if (!track.clientWidth && pogingen++ < 20) {
          window.requestAnimationFrame(plaats);
          return;
        }
        track.scrollLeft = index * track.clientWidth;
        count.textContent = (index + 1) + ' / ' + sources.length;
        markThumb(index);
        box.querySelector('.wwc-lb__close').focus();
      })();
    }

    function hide() {
      if (!box) return;
      box.classList.remove('is-open');
      document.body.classList.remove('wwc-lb-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // Openen vanaf het hoofdbeeld. Een tik op een LINK of KNOP in de galerij
    // (pijlen, videoknop) mag hier niet doorheen komen.
    gal.addEventListener('click', function (ev) {
      if (ev.target.closest('button, a')) return;
      var slide = ev.target.closest('[data-gal-slide]');
      if (!slide) return;
      if (slide.getAttribute('data-media-type') !== 'image') return;
      ev.preventDefault();
      /* data-index telt in de GALERIJ, inclusief de videoslide. De lightbox
         slaat die over, dus vertalen - anders opent hij een beeld naast het
         beeld waar je op tikte. */
      var galIndex = parseInt(slide.getAttribute('data-index') || '0', 10);
      var lbIndex = indexMap[galIndex];
      show(typeof lbIndex === 'number' && lbIndex >= 0 ? lbIndex : 0);
    });
  }


  /* =======================================================================
     4. GALERIJ: TOETSENBORD EN MEELOPENDE DUIMNAGELS

     Twee gebreken uit de audit:
     - de slider was niet met het toetsenbord te bedienen; de track had geen
       tabindex, dus pijltjestoetsen deden niets
     - op mobiel liep de duimnagelstrook niet mee als je voorbij het zichtbare
       deel veegde. Op desktop wel, omdat de strook daar breder is dan de rij.
     ======================================================================= */
  function galleryNav() {
    var gal = document.querySelector('wwc-product-gallery');
    if (!gal) return;
    var track = gal.querySelector('[data-gal-track]');
    var thumbsTrack = gal.querySelector('[data-gal-thumbs-track]');
    if (!track) return;

    // Focusbaar maken zodat pijltjestoetsen aankomen. role+label omdat een div
    // met tabindex anders niets betekent voor een schermlezer.
    if (!track.hasAttribute('tabindex')) {
      track.setAttribute('tabindex', '0');
      track.setAttribute('role', 'group');
      track.setAttribute('aria-label', gal.getAttribute('aria-label') || 'Productafbeeldingen');
    }

    track.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowRight' ? 1 : (e.key === 'ArrowLeft' ? -1 : 0);
      if (!d) return;
      e.preventDefault();
      track.scrollBy({ left: d * track.clientWidth, behavior: 'smooth' });
    });

    if (!thumbsTrack) return;

    // De actieve duimnagel in beeld houden. scrollIntoView zou de hele pagina
    // meenemen, dus we rekenen het zelf uit binnen de strook.
    var busy = false;
    track.addEventListener('scroll', function () {
      if (busy) return;
      busy = true;
      window.requestAnimationFrame(function () {
        busy = false;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        var t = thumbsTrack.children[i];
        if (!t) return;

        var horizontaal = thumbsTrack.scrollWidth > thumbsTrack.clientWidth;
        if (horizontaal) {
          var doel = t.offsetLeft - (thumbsTrack.clientWidth - t.offsetWidth) / 2;
          thumbsTrack.scrollTo({ left: Math.max(0, doel), behavior: 'smooth' });
        } else if (thumbsTrack.scrollHeight > thumbsTrack.clientHeight) {
          var doelY = t.offsetTop - (thumbsTrack.clientHeight - t.offsetHeight) / 2;
          thumbsTrack.scrollTo({ top: Math.max(0, doelY), behavior: 'smooth' });
        }
      });
    }, { passive: true });
  }


  /* =======================================================================
     5. CATEGORIEVIDEO: EMBED PAS BIJ KLIK

     De slide toont alleen de YouTube-poster. Pas als iemand op play drukt
     wordt de iframe geplaatst - dat scheelt ruim 500 kB en een set cookies op
     elke productpagina van iemand die de video nooit opent.

     autoplay=1 mag hier: het is een expliciete klik, geen automatisch geluid.
     ======================================================================= */
  function categoryVideo() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-wwc-video]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var id = btn.getAttribute('data-wwc-video');
      var frame = btn.closest('.wwc-gal__frame');
      if (!id || !frame) return;

      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      iframe.title = btn.getAttribute('aria-label') || 'Video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture';
      iframe.setAttribute('allowfullscreen', '');
      frame.appendChild(iframe);
      btn.remove();

      if (window.dataLayer) window.dataLayer.push({ event: 'wwc_video_play', video_id: id });
    }, true);
  }

  function init() {
    try { breadcrumb(); } catch (e) {}
    try { materialIntro(); } catch (e) {}
    try { lightbox(); } catch (e) {}
    try { galleryNav(); } catch (e) {}
    try { categoryVideo(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===========================================================================
   Video in een FAQ-antwoord: iframe pas bij een tik

   De poster staat er als gewone afbeelding; de YouTube-iframe komt er pas in
   wanneer iemand hem echt wil zien. Anders laadt elke geopende vraag een
   iframe van een paar honderd KB, ook bij wie de video nooit aanzet.

   youtube-nocookie: geen tracking-cookie tot er daadwerkelijk gespeeld wordt.
   =========================================================================== */
(function () {
  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('.wwc-hub2__video-knop');
    if (!knop) return;
    var doos = knop.closest('[data-hub-video]');
    if (!doos) return;
    var id = doos.getAttribute('data-hub-video');
    if (!id) return;

    var frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + id +
                '?autoplay=1&rel=0&modestbranding=1';
    frame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture');
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('title', knop.getAttribute('aria-label') || 'Video');
    knop.replaceWith(frame);

    if (window.dataLayer) {
      window.dataLayer.push({ event: 'wwc_faq_video', video_id: id });
    }
  }, true);
})();


/* ===========================================================================
   FAQ-afbeeldingen: laden zodra de vraag opengaat
   ===========================================================================
   De maatvoeringstekeningen en materiaalstalen staan in het antwoord van een
   <details> die dicht begint. Met loading="lazy" laadden ze NOOIT - ook niet
   na openen, ook niet na in beeld scrollen, ook niet na een echte muisklik.
   Nagemeten in de browser: naturalWidth bleef 0 terwijl dezelfde URL via
   new Image() gewoon 900x900 teruggaf. Het is dus geen netwerk- of URL-fout
   maar de lazy-loader die binnen een dichte details niet opnieuw evalueert.

   loading="lazy" er dan maar afhalen zou betekenen dat elke productpagina drie
   afbeeldingen ophaalt die vrijwel niemand openklapt. Vandaar data-src plus
   deze handler: geen byte tot iemand de vraag opent, en dan gegarandeerd wel.

   toggle bubbelt niet, dus luisteren we in de capture-fase op document.
   ========================================================================= */
(function () {
  function laad(wortel) {
    wortel.querySelectorAll('img[data-src]').forEach(function (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    laad(d);
  }, true);
})();


/* ===========================================================================
   FAQ-afbeeldingen schermvullend openen
   ===========================================================================
   De maatvoeringstekeningen en materiaalstalen stonden eerst op volle breedte
   in het antwoord: twee beelden van bijna 700 px hoog duwden de rest van de
   FAQ compleet uit beeld. Nu zijn het duimnagels van 130 px die je opent.

   Ze openden ook in een NIEUW TABBLAD (target="_blank" op de <a>). Vanaf een
   productpagina wil je de bezoeker nergens heen sturen - ook niet naar een los
   plaatje, want de weg terug is dan een browserknop.

   Deze lightbox hergebruikt de opmaak van de galerij-lightbox (.wwc-lb) zodat
   het er hetzelfde uitziet. Hij bouwt geen carrousel: één beeld, sluiten met
   Escape, met een klik ernaast of met de knop. De <a href> blijft staan, dus
   zonder JavaScript werkt de link gewoon nog.
   ========================================================================= */
(function () {
  var box = null;

  function maak() {
    box = document.createElement('div');
    box.className = 'wwc-lb wwc-lb--enkel';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Afbeelding vergroot');
    box.innerHTML = '<div class="wwc-lb__track"><div class="wwc-lb__slide"><img alt=""></div></div>' +
                    '<button type="button" class="wwc-lb__close" aria-label="Sluiten">&times;</button>';
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.closest('.wwc-lb__close')) sluit();
    });
    document.body.appendChild(box);
  }

  function open(src, alt) {
    if (!box) maak();
    var img = box.querySelector('img');
    img.src = src; img.alt = alt || '';
    box.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    box.querySelector('.wwc-lb__close').focus();
  }

  function sluit() {
    if (!box) return;
    box.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-hub-lightbox]');
    if (!a) return;
    e.preventDefault();
    open(a.getAttribute('href'), (a.querySelector('img') || {}).alt);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') sluit();
  });
})();
